import React from 'react';
import taxonomie from '../../constants/taxonomyConfig.json';
import ZoneAutocomplete from './ZoneAutocomplete';

const PROFILS = taxonomie.operations.cession.objets.fonds_de_commerce.profils;

/** `hotel` et `hotel_meuble` ne forment qu'une entrée « Hôtels » (lot DI § 2). */
export const sousProfilsDe = (profil) => {
  if (!profil || !PROFILS[profil]) return [];
  const entrees = Object.entries(PROFILS[profil].sous_profils || {});
  const liste = [];
  let hotelsAjoutes = false;
  entrees.forEach(([cle, libelle]) => {
    if (cle === 'hotel' || cle === 'hotel_meuble') {
      if (!hotelsAjoutes) { liste.push({ cle: 'hotel', libelle: 'Hôtels' }); hotelsAjoutes = true; }
      return;
    }
    liste.push({ cle, libelle });
  });
  return liste;
};

export const profilsCession = () =>
  Object.entries(PROFILS).map(([cle, bloc]) => ({ cle, libelle: bloc.label }));

/** Ligne de filtres : zone · activité · période · interrupteur portefeuille. */
export const FiltresObservatoire = ({ filtres, zoneLibelle, onChanger }) => {
  const { zoneType, zone, profil, sousProfil, mois, portefeuille } = filtres;

  return (
    <div
      className="bg-white rounded-xl border border-slate-200 p-4 flex flex-col xl:flex-row xl:items-end gap-3 text-left"
      data-testid="observatoire-filtres"
    >
      <div className="xl:w-72">
        <ZoneAutocomplete
          zoneType={zoneType}
          zone={zone}
          libelle={zoneLibelle}
          onChoisir={(s) => onChanger({ zoneType: s.type, zone: s.cle })}
          onEffacer={() => onChanger({ zoneType: null, zone: null })}
        />
      </div>

      {/* lot DK3 — deux colonnes sous 1 280 px : les menus restent lisibles */}
      <div className="grid grid-cols-2 gap-3 xl:flex xl:items-end xl:gap-3 xl:flex-1">
        <div className="min-w-0 col-span-2 sm:col-span-1">
          <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1">
            Activité
          </label>
          <select
            value={profil || ''}
            onChange={(e) => onChanger({ profil: e.target.value || null, sousProfil: null })}
            data-testid="observatoire-profil"
            className="w-full h-11 px-2 rounded-lg border border-slate-300 text-sm bg-white"
          >
            <option value="">Toutes activités</option>
            {profilsCession().map((p) => (
              <option key={p.cle} value={p.cle}>{p.libelle}</option>
            ))}
          </select>
        </div>

        <div className="min-w-0">
          <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1">
            Précision
          </label>
          <select
            value={sousProfil || ''}
            onChange={(e) => onChanger({ sousProfil: e.target.value || null })}
            disabled={!profil}
            data-testid="observatoire-sous-profil"
            className="w-full h-11 px-2 rounded-lg border border-slate-300 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-400"
          >
            <option value="">{profil ? 'Tout le profil' : '—'}</option>
            {sousProfilsDe(profil).map((s) => (
              <option key={s.cle} value={s.cle}>{s.libelle}</option>
            ))}
          </select>
        </div>

        <div className="min-w-0">
          <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1">
            Période
          </label>
          <select
            value={mois}
            onChange={(e) => onChanger({ mois: Number(e.target.value) })}
            data-testid="observatoire-mois"
            className="w-full h-11 px-2 rounded-lg border border-slate-300 text-sm bg-white"
          >
            <option value={12}>12 mois</option>
            <option value={24}>24 mois</option>
            <option value={36}>36 mois</option>
          </select>
        </div>
      </div>

      {/* Téléphone et tablette : l'interrupteur occupe toute la largeur, hauteur 44 px */}
      <button
        type="button"
        role="switch"
        aria-checked={portefeuille}
        onClick={() => onChanger({ portefeuille: !portefeuille })}
        data-testid="observatoire-portefeuille-toggle"
        className={`h-11 px-3 w-full xl:w-auto rounded-lg border flex items-center gap-2.5 shrink-0 transition ${
          portefeuille ? 'border-[#EB6834] bg-orange-50' : 'border-slate-300 bg-white'
        }`}
      >
        <span
          className={`w-10 h-6 rounded-full relative transition ${portefeuille ? 'bg-[#EB6834]' : 'bg-slate-300'}`}
        >
          <span
            className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-all ${portefeuille ? 'left-[18px]' : 'left-0.5'}`}
          ></span>
        </span>
        <span className={`text-sm font-semibold ${portefeuille ? 'text-slate-800' : 'text-slate-600'}`}>
          Comparer avec mon portefeuille
        </span>
      </button>
    </div>
  );
};

export default FiltresObservatoire;
